import { FOOTER_MJML } from "../common/footer";
import { PRODUCT_HEADER } from "../common/header";

export const productSurvey = `
<mjml>
  <mj-head>
    <mj-title>Your Opinion Shapes Our Future</mj-title>
    <mj-preview>Take our quick survey and help us improve {{product_name}}</mj-preview>
    <mj-attributes>
      <mj-all font-family="Arial, sans-serif" />
      <mj-text font-size="16px" color="#333333" line-height="1.5" />
    </mj-attributes>
    <mj-style>
      .survey-container {
        border: 1px solid #e0e0e0;
        border-radius: 8px;
        overflow: hidden;
      }
      .survey-section {
        border-bottom: 1px solid #e0e0e0;
      }
      .last-section {
        border-bottom: none;
      }
      .reward-box {
        background-color: #f0f7ff;
        border-radius: 8px;
        border: 1px dashed #1890ff;
      }
      .time-indicator {
        background-color: #e6f7ff;
        border-radius: 16px;
        display: inline-block;
        padding: 3px 12px;
        color: #1890ff;
        font-weight: bold;
        font-size: 14px;
      }
      .step-number {
        display: inline-block;
        width: 28px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        border-radius: 14px;
        background-color: #1890ff;
        color: white;
        font-weight: bold;
        margin-right: 8px;
      }
    </mj-style>
  </mj-head>
  <mj-body background-color="#f5f5f5">
    ${PRODUCT_HEADER("Product Survey", "Your insights drive our improvements")}
    
    <!-- Introduction section -->
    <mj-section background-color="#ffffff" padding="30px" border-radius="8px">
      <mj-column>
        <mj-text font-size="22px" color="#333333" font-family="Arial, sans-serif">Hello {{first_name}},</mj-text>
        <mj-text font-size="16px" color="#555555" font-family="Arial, sans-serif">
          We value your opinion and would love to hear your thoughts on {{product_name}}. Your feedback directly impacts our product roadmap and helps us create a better experience for you.
        </mj-text>
        <mj-text font-size="16px" color="#555555" font-family="Arial, sans-serif">
          <span class="time-indicator">Only 5 minutes</span> of your time could make a significant difference in shaping the future of our product.
        </mj-text>
      </mj-column>
    </mj-section>
    
    <!-- Survey preview section -->
    <mj-section background-color="#ffffff" padding="20px 30px 0" border-radius="8px">
      <mj-column>
        <mj-text font-size="20px" color="#333333" font-weight="bold">What we'll ask you about:</mj-text>
      </mj-column>
    </mj-section>
    
    <mj-section background-color="#ffffff" padding="10px 30px 30px" border-radius="8px">
      <mj-column width="100%" css-class="survey-container">
        <mj-section padding="15px 20px" css-class="survey-section">
          <mj-column width="15%">
            <mj-image src="https://via.placeholder.com/50?text=1" alt="Usage" width="50px" />
          </mj-column>
          <mj-column width="85%">
            <mj-text font-size="18px" font-weight="bold" padding-bottom="5px">
              Your Usage Patterns
            </mj-text>
            <mj-text font-size="16px" color="#555555" padding-top="0">
              How you use {{product_name}} and which features matter most
            </mj-text>
          </mj-column>
        </mj-section>
        
        <mj-section padding="15px 20px" css-class="survey-section">
          <mj-column width="15%">
            <mj-image src="https://via.placeholder.com/50?text=2" alt="Experience" width="50px" />
          </mj-column>
          <mj-column width="85%">
            <mj-text font-size="18px" font-weight="bold" padding-bottom="5px">
              User Experience
            </mj-text>
            <mj-text font-size="16px" color="#555555" padding-top="0">
              Your satisfaction with our interface and workflow
            </mj-text>
          </mj-column>
        </mj-section>
        
        <mj-section padding="15px 20px" css-class="survey-section">
          <mj-column width="15%">
            <mj-image src="https://via.placeholder.com/50?text=3" alt="Features" width="50px" />
          </mj-column>
          <mj-column width="85%">
            <mj-text font-size="18px" font-weight="bold" padding-bottom="5px">
              Feature Requests
            </mj-text>
            <mj-text font-size="16px" color="#555555" padding-top="0">
              What you'd like to see in future updates
            </mj-text>
          </mj-column>
        </mj-section>
        
        <mj-section padding="15px 20px" css-class="last-section">
          <mj-column width="15%">
            <mj-image src="https://via.placeholder.com/50?text=4" alt="Satisfaction" width="50px" />
          </mj-column>
          <mj-column width="85%">
            <mj-text font-size="18px" font-weight="bold" padding-bottom="5px">
              Overall Satisfaction
            </mj-text>
            <mj-text font-size="16px" color="#555555" padding-top="0">
              Your likelihood to recommend {{product_name}}
            </mj-text>
          </mj-column>
        </mj-section>
      </mj-column>
    </mj-section>
    
    <!-- Reward section -->
    <mj-section background-color="#ffffff" padding="0 30px 30px" border-radius="8px">
      <mj-column css-class="reward-box" padding="20px">
        <mj-text font-size="18px" color="#333333" font-weight="bold" align="center">
          {{reward_title}}
        </mj-text>
        <mj-text font-size="16px" color="#555555" align="center">
          {{reward_description}}
        </mj-text>
        <mj-image src="https://via.placeholder.com/300x150?text=Survey+Reward" alt="Survey Reward" width="300px" />
      </mj-column>
    </mj-section>
    
    <!-- How to participate section -->
    <mj-section background-color="#ffffff" padding="30px" border-radius="8px">
      <mj-column>
        <mj-text font-size="20px" color="#333333" font-weight="bold">How to participate:</mj-text>
        <mj-divider border-color="#e0e0e0" border-width="1px" padding-bottom="15px" />
        
        <mj-text font-size="16px" color="#555555">
          <span class="step-number">1</span> Click the button below to start the survey
        </mj-text>
        <mj-text font-size="16px" color="#555555">
          <span class="step-number">2</span> Answer the questions honestly (it takes just 5 minutes)
        </mj-text>
        <mj-text font-size="16px" color="#555555">
          <span class="step-number">3</span> Submit your responses before {{survey_deadline}}
        </mj-text>
        <mj-text font-size="16px" color="#555555">
          <span class="step-number">4</span> {{reward_claim_step}}
        </mj-text>
        
        <mj-button background-color="#1890ff" color="#ffffff" font-family="Arial, sans-serif" href="{{survey_url}}" width="250px" border-radius="4px" font-weight="bold" font-size="16px" align="center" padding-top="20px">
          Take the Survey Now
        </mj-button>
      </mj-column>
    </mj-section>
    
    <!-- Thank you section -->
    <mj-section background-color="#ffffff" padding="30px" border-radius="8px">
      <mj-column>
        <mj-text font-size="16px" color="#555555">
          Thank you for being a valued customer. Your input will directly influence our product development.
        </mj-text>
        <mj-text font-size="16px" color="#555555">
          Best regards,<br />
          The {{company_name}} Team
        </mj-text>
      </mj-column>
    </mj-section>
    
    ${FOOTER_MJML}
  </mj-body>
</mjml>
`;

// Template metadata for the gallery
export default {
  id: "productSurvey",
  name: "Product Survey Invitation",
  category: "product",
  description:
    "An engaging and visually appealing email template designed to encourage customers to participate in a product survey, with clear incentives and streamlined user flow.",
  features: [
    "Survey topic preview with icons",
    "Time commitment indicator",
    "Reward/incentive highlight box",
    "Step-by-step participation guide",
    "Mobile-responsive design",
  ],
  subject: "Your Opinion Shapes Our Future",
  subTitle: "Take our quick survey and help us improve our product",
  mjmlTemplate: productSurvey,
};
